import { Button as AntButton, Modal } from "antd";
import _ from "lodash";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { deleteShuttleAmount, updateShuttleAmount } from "../../../../api/payments.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import { getVat } from "../../../../lib/util";
import { IStudentPayment } from "../../../../models/payments.model";
import { RootState } from "../../../../store/rootReducer";
import { setSortedStudentPayments } from "../../../../store/student.student.slice";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";
import { IStudent } from '../../../../models/students.model';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  record: IStudentPayment|undefined;
  student?: IStudent;
  doGetStudentPayments: () => void;
}

const ShuttleAmountModal: FC<IProps> = ({
  visible,
  setVisible,
  record,
  doGetStudentPayments
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { sortedStudentPayments } = useSelector((root: RootState) => root.studentStudent);

  const { infoNotification, successNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();
  const { data: deleteRes, isLoading: deleteIsLoading, error: deleteError, execute: deleteExecute } = useAxios();

  const [price, setPrice] = useState('');

  useEffect(() => {
    if (record) {
      setPrice(String(record.price));
    }
  }, [record]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.edit1'));
      updateListItem();
      doGetStudentPayments(); //셔틀 금액이 수정되었을 때, 전체 결제 내역을 다시 받아 온다.
      onClose();
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      successNotification(t('common.message.delete'));
      doGetStudentPayments(); //셔틀 금액이 수정되었을 때, 전체 결제 내역을 다시 받아 온다.
      deleteListItem();
      onClose();
    }
  }, [deleteRes, deleteIsLoading]);

  const updateListItem = () => {
    const _list = _.cloneDeep(sortedStudentPayments);
    const item = _list.find(item => item.paymentNo === record?.paymentNo);
    if (item) item.price = Number(price);
    dispatch(setSortedStudentPayments(_list));
  }

  const deleteListItem = () => {
    const _list = _.cloneDeep(sortedStudentPayments);
    const index = _list.findIndex(item => item.paymentNo === record?.paymentNo);
    if (index > -1) _list.splice(index, 1);
    dispatch(setSortedStudentPayments(_list));
  }

  const onSubmit = () => {
    if (!record) return;

    if (!price) {
      return infoNotification(t('student.student.message27'));
    }

    if (price === '0') {
      deleteExecute(deleteShuttleAmount(record.paymentNo));
    } else {
      submitExecute(updateShuttleAmount({
        paymentNo: record.paymentNo,
        price: Number(price),
        taxAmt: getVat(Number(price)),
      }));
    }
  }

  const onClose = () => {
    setPrice('');
    setVisible(false);
  }

  return (
    <>
      {submitIsLoading || deleteIsLoading ? <Loader /> : null}
      <ErrorResponse error={submitError} />
      <ErrorResponse error={deleteError} />

      <Modal
        title={t('student.student.title10')}
        visible={visible}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton key="submit" className='btn-basic pink' onClick={onSubmit}>
              {t('common.button.edit')}
            </AntButton>
            <AntButton key="cancel" className='btn-basic gray' onClick={onClose}>
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-center">
          <div className="v-line mr-1">{t('student.student.option18')}:</div>
          <div className="w-150p">
            <input
              type="text"
              className="form-control input-text"
              value={price}
              onChange={e => setPrice(e.target.value)}
            />
          </div>
        </div>
        <div className="text-center">
          ({t('student.student.text14')})
        </div>
      </Modal>
    </>
  );
}

export default ShuttleAmountModal;
